require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// /Users/shakyshane/Sites/oss/UI/~/angular/index.js
// module id = 2
// module chunks = 0